import { HomeComponent } from './home.component';

export const HomeRoutes: Array<any> = [
  {path: '', component: HomeComponent}
];



// WEBPACK FOOTER //
// ./src/app/components/home/home.routes.ts